import React, { Component, Fragment } from 'react';
import { MSG_ERR, MSG_OK, MSG_WARN } from '../App';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';
import EmptyState from './EmptyState';



const DOLLARS_PER_POINT = 10
const MINIMUM_WITHDRAWAL = 10



class Transacions extends Component {

    state = {
        transactions: [],
        isLoaded: false
      }    

    
    getTransacions = () => {
        const { displayMsg } = this.props;
        const params = {
            colId: localStorage.getItem('colId'),
        }
        
        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }

        if (!params.colId) this.displayMsg("Need to login first", MSG_ERR)
        else {

            this.setState({ transactions: [], isLoaded: false })
            axios
                .get('/api/transaction/', { params, headers: json_headers })
                .then(res => {
                    this.setState({
                        transactions: res.data,
                        isLoaded: true
                
                    })
                    if (!res.data)                     displayMsg("No transacions loaded", MSG_WARN)
                })
                .catch(() => {
                    displayMsg("Error Loading Transacions. Please Try again.", MSG_ERR)
                })
        }
    }
    
    onWhithDrawl = () => {
        const { displayMsg } = this.props;
        const currentBalance = this.state.transactions.length > 0
            ? this.state.transactions[0].trans_balance
            : 0
        const amountUsd = Math.floor(currentBalance / DOLLARS_PER_POINT)

        const json_headers = {
            'Content-Type': 'application/json',
            'X-CSRFToken': localStorage.getItem('csrftoken'),
            Authorization: `Token ${localStorage.getItem('token')}`
        }

        axios
            .post('/api/withdrawal/', {
                wdrl_col: localStorage.getItem('colId'),
                wdrl_amount_usd: amountUsd,
            }, { headers: json_headers })
            .then(() => {
                displayMsg(`Retiro Solicitado: Status Pending`, MSG_OK)
                window.scrollTo(0, 0)
                this.getTransacions()
            })
            .catch(() => {
                displayMsg("Error al solicitar el retiro. Intente de nuevo.", MSG_ERR)
                window.scrollTo(0, 0)
            })
    }


    componentDidMount() {
        this.getTransacions();
        
    };

    
   formatDate = datetime => {
        return new Date(datetime).toLocaleString()
    }


    render() {
        
        let currentBalance = 0

        if (this.state.isLoaded === false) {
            return <LoadingSpinner message="Cargando transacciones…" />
        }
        if (this.state.transactions.length === 0) {
            return <EmptyState message="No hay transacciones registradas." />
        }
        {

            if (this.state.transactions[0]) {
                currentBalance = this.state.transactions[0].trans_balance
            }
            


            return (
                <Fragment>
                    <nav className="navbar-light bg-light py-2 position-relative" > 
                        <a className="navbar-brand"> Ultimas 20 Transaciones<br />
                        <font size="2">
                                Saldo Inicial al {this.state.transactions.at(-1).trans_datetime}: {'  '}
                                {this.state.transactions.at(-1).trans_balance - this.state.transactions.at(-1).trans_amount} Ptos.
                        </font>
                        </a>
                    </nav>
                    <font size="1">
                    <table className="table table-striped" >
                    <thead>
                        <tr>
                            <th> Fecha/Hora</th>
                            <th> Puntos</th>
                            <th> Balance</th>
                            <th> Descripcion</th>
                            <th />
                        </tr>
                    </thead>
                    <tbody>
                            {this.state.transactions.map((tr, idx) => (
                            <tr key={tr.id}>
                                <td>{this.formatDate(tr.trans_datetime)}</td>
                                <td>{tr.trans_amount}</td>
                                <td>{tr.trans_balance}</td>
                                <td>{tr.trans_support}</td>

                            </tr>
                        ))}
                    </tbody>
                    </table>
                    </font>
                    <a><font size="2">Saldo Actual: {currentBalance} Ptos.</font></a><br />
                    <button className="btn btn-primary m-2"
                            disabled={Math.floor(currentBalance / DOLLARS_PER_POINT) < MINIMUM_WITHDRAWAL}
                            onClick={this.onWhithDrawl}>
                        Retiro (${Math.floor(currentBalance / DOLLARS_PER_POINT)})
                    </button>
                    {Math.floor(currentBalance / DOLLARS_PER_POINT) < MINIMUM_WITHDRAWAL &&
                        <div><small className="text-muted">Retiro Mínimo: ${MINIMUM_WITHDRAWAL} ({MINIMUM_WITHDRAWAL * DOLLARS_PER_POINT} Ptos)</small></div>
                    }

                </Fragment>
            )
        }
    }
}
 
export default Transacions;